export const ScreenSize = {
    DESKTOP: 1279,
    MOBILE: 699,
} as const;
